import { YearProduction } from "./types";

export const generateYearsProduction = (startYear: number, endYear: number): YearProduction[] => {
    const years: YearProduction[] = [];
    for (let year = endYear; year >= startYear; year--) {
        years.push({ value: `${year}`, label: `${year}` });
    }
    return years;
};